import './MyPackagesScreenPage.css'

import { useEffect } from 'react'
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom'

import { useUserPackages } from '../../../api/user-package/queries/useUserPackages'
import accountCircleIcon from '../../../imgs/account_circle_white-logo_18dp.svg'
import historyIcon from '../../../imgs/history_white_logo_18dp.svg'
import packagesIcon from '../../../imgs/packages_2_white_18dp.svg'
// Icons
import affiliateIcon from '../../../imgs/people.png'
//Components
import TheFooter from '../TheFooter'
import AffiliateComponent from './AffiliateComponent'
import OrderHistoryComponent from './OrderHistoryComponent'
import PersonalInfoComponent from './PersonalInfoComponent'
import TableForMyPackagesPage from './TableForMyPackagesPage'

export default function MyPackagesScreenPage() {
  let { path, url } = useRouteMatch()
  useUserPackages()
  useEffect(() => {
    document.title = 'האזור האישי | ShipTanbul'
  }, [])

  return (
    <div
      style={{
        marginTop: '60px',
        minHeight: 'calc(100vh - 60px )',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flexGrow: '1' }}>
        <div className='personal-info-navbar'>
          <NavLink exact to={`${url}`} activeClassName='pin-link-active'>
            <div className='pin-link'>
              <img alt='user icon' src={accountCircleIcon} />
              <div>פרטים אישיים</div>
            </div>
          </NavLink>
          <NavLink to={`${url}/myPackages`} activeClassName='pin-link-active'>
            <div className='pin-link'>
              <img alt='user icon' src={packagesIcon} />
              <div>החבילות שלי</div>
            </div>
          </NavLink>
          <NavLink to={`${url}/packageHistory`} activeClassName='pin-link-active'>
            <div className='pin-link'>
              <img alt='user icon' src={historyIcon} />
              <div>חבילות שנשלחו</div>
            </div>
          </NavLink>
          <NavLink to={`${url}/affiliate`} activeClassName='pin-link-active'>
            <div className='pin-link'>
              <img alt='user icon' src={affiliateIcon} />
              <div>שיווק שותפים</div>
            </div>
          </NavLink>
        </div>

        <Switch>
          <Route exact path={path}>
            <PersonalInfoComponent />
          </Route>
          <Route path={`${path}/myPackages`}>
            <TableForMyPackagesPage />
          </Route>
          <Route path={`${path}/packageHistory`}>
            <OrderHistoryComponent />
          </Route>
          <Route path={`${path}/affiliate`}>
            <AffiliateComponent />
          </Route>
        </Switch>
      </div>

      {/* <Modal size="l" show={show} onHide={() => setShow(false)} centered>
        <div className="contact-modal" style={{ direction: 'rtl' }}>
          <img src={logo} className="contact-modal-logo" />
          <h2>שיפטנבולים יקרים ❤️</h2>
          <p style={{fontWeight:"normal"}}>
            <br />
            לצערנו אנו נאלצים להפסיק כרגע את הפעילות שלנו בטורקיה לאור ההחלטות של הממשלה הטורקית.
            <br />
            <br />
            אבל שום דבר לא יעצור אותנו ומצפות לכם הפתעות בהמשך ✨
          </p>
          <Button onClick={() => setShow(false)}>סגור</Button>
        </div>
      </Modal> */}

      <section>
        <TheFooter />
      </section>
    </div>
  )
}
